import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["text", "expandIcon", "collapseIcon", "button"]
  static values = { showMoreLabel: String, showLessLabel: String }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const expanded = this.textTarget.classList.contains("overflow-y-auto")
    this.textTarget.classList.toggle("max-h-[9rem]", !expanded)
    this.textTarget.classList.toggle("overflow-y-auto", !expanded)
    this.textTarget.classList.toggle("max-h-[4.5rem]", expanded)
    this.textTarget.classList.toggle("overflow-hidden", expanded)

    if (this.hasExpandIconTarget) this.expandIconTarget.classList.toggle("hidden", !expanded)
    if (this.hasCollapseIconTarget) this.collapseIconTarget.classList.toggle("hidden", expanded)
    if (this.hasButtonTarget) {
      const label = expanded ? this.showMoreLabelValue : this.showLessLabelValue
      this.buttonTarget.setAttribute("title", label)
      this.buttonTarget.setAttribute("aria-label", label)
    }
  }
}
